import { render, staticRenderFns } from "./message_marketing.vue?vue&type=template&id=424897e4&scoped=true"
import script from "./message_marketing.vue?vue&type=script&lang=js"
export * from "./message_marketing.vue?vue&type=script&lang=js"
import style0 from "./message_marketing.vue?vue&type=style&index=0&id=424897e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424897e4",
  null
  
)

export default component.exports